export default __webpack_public_path__ + "static/media/thumb_2_woz.e75c5ce8.png";